import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Row, Col, Container, Button, Modal, ModalHeader, ModalBody } from 'reactstrap'
import { ReactComponent as CopySolid } from '../../images/copy-solid.svg'
import { ReactComponent as Javascript } from '../../images/javascript.svg'
import { ReactComponent as Apple } from '../../images/apple.svg'
import { ReactComponent as Android } from '../../images/android.svg'
import { ReactComponent as ReactNative } from '../../images/react.svg'
import { ReactComponent as API } from '../../images/code.svg'
import './index.scss'
import javascriptInstructions from './javascript'
import swiftInstructions from './swift'
import apiInstructions from './api'
import reactInstructions from './react'

const extended = false

export default function Sdk ({ account }) {
  const [coreEventName, setCoreEventName] = useState('default')
  const [, setDelay] = useState('2 week')
  const [, setOccurences] = useState(3)
  const [language, setLanguage] = useState('js')
  const [recordEvent, setRecordEvent] = useState('default')
  const [getCommand, setGetCommand] = useState(false)
  const [codePreview, setCodePreview] = useState(false)

  useEffect(() => {
    generate(language)
  }, [])

  const open = (lang) => {
    setLanguage(lang)
    generate(lang)
    setCodePreview(true)
  }

  const toggle = () => {
    setCodePreview(false)
  }

  const copyCode = (code) => {
    navigator.clipboard.writeText(code)
    toast.info('Code copied to clipboard')
  }

  const generate = (lang) => {
    console.log('generate', lang)
    if (lang === 'js') {
      const { re, gc } = javascriptInstructions(account, coreEventName)
      setRecordEvent(re)
      setGetCommand(gc)
    } else if (lang === 'ios') {
      const { re, gc } = swiftInstructions(account, coreEventName)
      setRecordEvent(re)
      setGetCommand(gc)
    } else if (lang === 'api') {
      const { re, gc } = apiInstructions(account, coreEventName)
      setRecordEvent(re)
      setGetCommand(gc)
    } else if (lang === 'react') {
      console.log('not react?')
      const { re, gc } = reactInstructions(account, coreEventName)
      setRecordEvent(re)
      setGetCommand(gc)
    } else {
      const re = `We are working on the ${lang} version of our sdk. It will be available soon.`
      const gc = `We are working on the ${lang} version of our sdk. It will be available soon.`
      setRecordEvent(re)
      setGetCommand(gc)
    }
  }

  return (
    <div className="sdk-container">
      <Row>
        <p>For even better results, add the PMF survey in your project and trigger it at the key event that you identified as the most important for your users to experience the benefit of your project.</p>
      </Row>

      {extended &&
        <>
          <Row>
            <Col>
              <Container>
                <Row>
                  <label>Name of your event<br />(it can be anything)&nbsp;</label>
                </Row>
                <Row>
                  <input type="text" placeholder="Your event name" onChange={(e) => setCoreEventName(e.target.value)} />
                </Row>
              </Container>
            </Col>

            <Col>
              <Container>
                <Row>
                  <label>When to show the form? <br />format: [number] [day/week/month]</label>
                </Row>
                <Row>
                  <input type="text" placeholder="2 week" onChange={(e) => setDelay(e.target.value)} />
                </Row>
              </Container>
            </Col>

            <Col>
              <Container>
                <Row>
                  <label>Minimum number of core event occurrences to show the form</label>
                </Row>
                <Row>
                  <input type="text" placeholder="3" onChange={(e) => setOccurences(e.target.value)} />
                </Row>
              </Container>
            </Col>
          </Row>

          <Row>
            <Col></Col>
            <Col><Button color="primary" onClick={() => generate(language)}>Generate</Button></Col>
            <Col></Col>
          </Row>
        </>
      }

      {recordEvent &&
        <>
          <Row className="sdk-buttons">
            <Col>
              <div className="sdk-button" onClick={() => open('js')}>
                <div className="logo">
                  <Javascript />
                </div>
                <div className="text">
                  JavaScript
                </div>
              </div>
            </Col>
            <Col>
              <div className="sdk-button" onClick={() => open('ios')}>
                <div className="logo">
                  <Apple />
                </div>
                <div className="text">
                  iOS Swift
                </div>
              </div>
            </Col>
            <Col>
              <div className="sdk-button" onClick={() => open('android')}>
                <div className="logo">
                  <Android />
                </div>
                <div className="text">
                  Android
                </div>
              </div>
            </Col>
            <Col>
              <div className="sdk-button" onClick={() => open('api')}>
                <div className="logo">
                  <API />
                </div>
                <div className="text">
                  API
                </div>
              </div>
            </Col>
            <Col>
              <div className="sdk-button" onClick={() => open('react')}>
                <div className="logo">
                  <ReactNative />
                </div>
                <div className="text">
                  React &amp; React Native
                </div>
              </div>
            </Col>
          </Row>

          <Modal isOpen={codePreview} toggle={toggle} className="form-preview sdk-instructions" size="lg">
            <ModalHeader toggle={toggle}>Integration instructions</ModalHeader>
            <ModalBody>

            {language === 'js' &&
                <Container>
                  {recordEvent &&
                    <Row className="code-box">
                      <h3>Record core event</h3>
                      <pre className="code">
                        {recordEvent}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(recordEvent)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  {getCommand &&
                    <Row className="code-box">
                      <h3>Check if form is ready to be shown</h3>
                      <pre className="code">
                        {getCommand}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(getCommand)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  <Row>
                    <p>
                      Documentation: <a
                      className="documentation-link"
                      style={{ color: 'var(--color-14)' }}
                      href="https://www.npmjs.com/package/pmf-engine-sdk"
                      target="_blank"
                      rel="noreferrer">
                        https://www.npmjs.com/package/pmf-engine-sdk
                      </a>
                    </p>
                  </Row>
                </Container>
              }
              {language === 'react' &&
                <Container>
                  {recordEvent &&
                    <Row className="code-box">
                      <h3>Record core event</h3>
                      <pre className="code">
                        {recordEvent}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(recordEvent)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  {getCommand &&
                    <Row className="code-box">
                      <h3>Check if form is ready to be shown</h3>
                      <pre className="code">
                        {getCommand}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(getCommand)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  <Row>
                    <p>
                      Documentation: <a
                      className="documentation-link"
                      style={{ color: 'var(--color-14)' }}
                      href="https://www.npmjs.com/package/pmf-engine-sdk"
                      target="_blank"
                      rel="noreferrer">
                        https://www.npmjs.com/package/pmf-engine-sdk
                      </a>
                    </p>
                  </Row>
                </Container>
              }
              {language === 'ios' &&
                <Container>
                  {recordEvent &&
                    <Row className="code-box">
                      <h3>Record core event</h3>
                      <pre className="code">
                        {recordEvent}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(recordEvent)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  {getCommand &&
                    <Row className="code-box">
                      <h3>Check if form is ready to be shown</h3>
                      <pre className="code">
                        {getCommand}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(getCommand)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  <Row>
                    <p>
                      Documentation: <a
                        className="documentation-link"
                        style={{ color: 'var(--color-14)' }}
                        href="https://github.com/herbertbay/pmf-engine-swift"
                        target="_blank"
                        rel="noreferrer">
                        https://github.com/herbertbay/pmf-engine-swift
                      </a>
                    </p>
                  </Row>
                </Container>
              }
              {language === 'android' &&
                <Container>
                  {recordEvent &&
                    <Row className="code-box">
                      <h3>Record core event</h3>
                      <pre className="code">
                        {recordEvent}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(recordEvent)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  {getCommand &&
                    <Row className="code-box">
                      <h3>Check if form is ready to be shown</h3>
                      <pre className="code">
                        {getCommand}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(getCommand)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  <Row>
                    <p>
                      Documentation: <a
                        className="documentation-link"
                        style={{ color: 'var(--color-14)' }}
                        href="https://github.com/herbertbay/pmf-engine-swift"
                        target="_blank"
                        rel="noreferrer">
                        https://github.com/herbertbay/pmf-engine-swift
                      </a>
                    </p>
                  </Row>
                </Container>
              }
              {language === 'api' &&
                <Container>
                  {recordEvent &&
                    <Row className="code-box">
                      <h3>Record core event</h3>
                      <pre className="code">
                        {recordEvent}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(recordEvent)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  {getCommand &&
                    <Row className="code-box">
                      <h3>Check if form is ready to be shown</h3>
                      <pre className="code">
                        {getCommand}
                      </pre>
                      <button
                        className="btn btn-primary copy-button"
                        onClick={() => copyCode(getCommand)}>
                          <CopySolid title='Copy' />
                      </button>
                    </Row>
                  }

                  <Row>
                    <p>
                      Documentation: <a
                        className="documentation-link"
                        style={{ color: 'var(--color-14)' }}
                        href="/api"
                        target="_blank"
                        rel="noreferrer">
                        API
                      </a>
                    </p>
                  </Row>
                </Container>
              }
            </ModalBody>
          </Modal>
        </>
      }
    </div>
  )
}
